<div class="order-list">
  @if (!orderList) {
    <div class="loading-list">
      <app-loading [hasOverlay]="false" class="mt-4" />
    </div>
  } @else {
    @for (order of orderList.data; track order.id) {
      <app-order-card
        [order]="order"
        (reloadTicketsAfterChange)="handleReloadTicketsAfterChange()"
        (openDetailsModalClick)="handleOpenModalClick($event)"
        (paymentClick)="handlePaymentClick($event)" />
    } @empty {
      <p class="p text-secondary">Nenhum ingresso a ser mostrado.</p>
    }
  }
</div>

<div class="actions-area">
  @if (orderList) {
    <p-paginator
      [first]="first"
      [rows]="rows"
      [totalRecords]="orderList.meta.total_count"
      (onPageChange)="handleLoadMoreClick($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} de {totalRecords}"
      [showPageLinks]="false"
      [showFirstLastIcon]="false"></p-paginator>
  }
</div>
